/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ContentContainer } from '../index';
import { TimesheetPagination } from '../Table/Timesheet/TimesheetPagination';
import { Grid } from '@mui/material';

export const CardContainer = (props) => {
  return (
    <ContentContainer style={{ p: 2 }}>
      <Grid spacing={props.spacing} container sx={{ mb: 3 }}>
        {props.children}
      </Grid>
      <TimesheetPagination
        count={
          props.length % props.entryPerPage !== 0
            ? props.pageCount + 1
            : props.pageCount
        }
        onChange={props.handlePageChange}
        noRecord={props.noRecord}
      />
    </ContentContainer>
  );
};
